import { useMemo } from "react"

import { useMetricRecordsById } from "@/metrics/registry"

import {
  buildMetricDisplayNameLookup,
  createMetricReferenceResolver,
} from "../utils/runsTableState"

export function useRunsMetricPresenceFilter(
  metricFilters: string[],
  enabled: boolean,
) {
  const metricDefinitions = useMetricRecordsById({
    enabled,
    referencedMetricIds: metricFilters,
  })
  const { metricRecordsById, metricIdAliases, isLoading, isError } =
    metricDefinitions
  const resolveMetricId = useMemo(
    () => createMetricReferenceResolver(metricRecordsById, metricIdAliases),
    [metricRecordsById, metricIdAliases],
  )
  const metricIdsFilter = useMemo(
    () => [...new Set(metricFilters.map(resolveMetricId))],
    [metricFilters, resolveMetricId],
  )
  const metricDisplayNames = useMemo(
    () => buildMetricDisplayNameLookup(metricRecordsById, metricIdAliases),
    [metricRecordsById, metricIdAliases],
  )
  const hasUnresolvedFilters = useMemo(() => {
    return metricIdsFilter.some((id) => !metricRecordsById[id]?.id)
  }, [metricIdsFilter, metricRecordsById])
  return {
    metricDisplayNames,
    metricDefinitions: {
      ...metricDefinitions,
      isError: isError || (enabled && !isLoading && hasUnresolvedFilters),
    },
    metricIdsFilter,
    queriesEnabled:
      enabled &&
      (metricFilters.length === 0 ||
        (!isLoading && !isError && !hasUnresolvedFilters)),
  }
}
